import { Backdrop, CircularProgress } from '@mui/material';

const ProgressBackdrop = ({ isLoading }: { isLoading: boolean }) => {
  return (
    <Backdrop
      sx={{
        position: 'absolute',
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={isLoading}
    >
      <CircularProgress />
    </Backdrop>
  );
};

export default ProgressBackdrop;
